import Patient from './Patient';

export default Patient;
